// Compound profile data keyed by catalog slug.
// Source: research team / PubChem references provided 2026-06.
// Only catalog slugs with a profile here will surface the "Compound Information" button.

export const COMPOUND_PROFILES = {
  "bpc-157": {
    name: "BPC-157",
    type: "Synthetic pentadecapeptide",
    aminoAcids: 15,
    formula: "C\u2086\u2082H\u2089\u2088N\u2081\u2086O\u2082\u2082",
    weight: "1,419.55 Da",
    mechanism: "Body Protective Compound. Supports tissue repair and cellular signaling.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/#query=BPC-157",
  },
  "epitalon": {
    name: "Epitalon",
    type: "Pineal tetrapeptide",
    aminoAcids: 4,
    formula: "C\u2081\u2084H\u2082\u2082N\u2084O\u2089",
    weight: "390.34 Da",
    mechanism: "Tetrapeptide (Ala-Glu-Asp-Gly). Telomerase activation pathway.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/307297-39-8",
  },
  "ghk-cu": {
    name: "GHK-Cu",
    type: "Copper tripeptide complex",
    aminoAcids: 3,
    formula: "C\u2081\u2084H\u2082\u2082CuN\u2086O\u2084",
    weight: "401.91 Da",
    mechanism: "Tripeptide (Gly-His-Lys) bound to Cu²⁺. Collagen synthesis and skin repair research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/73587",
  },
  "glp-2t": {
    name: "GLP-2T",
    type: "Dual GIP / GLP-1 receptor agonist",
    aminoAcids: 39,
    formula: "C\u2082\u2082\u2085H\u2083\u2084\u2088N\u2084\u2088O\u2086\u2088",
    weight: "4,813.53 Da",
    mechanism: "Modified incretin peptide. Metabolic and gastrointestinal research applications.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/156588324",
  },
  "glp-3r": {
    name: "GLP-3R (Retatrutide)",
    type: "Triple GIP / GLP-1 / Glucagon receptor agonist",
    aminoAcids: 39,
    formula: "C\u2082\u2082\u2081H\u2083\u2084\u2083FN\u2084\u2086O\u2087\u2080",
    weight: "4,731.33 Da",
    mechanism: "Non-coded residues (Aib\u00B2, Aib\u00B2\u2070, αMeL\u00B9\u00B3) and C20 fatty-acid conjugation for extended half-life and albumin binding. Metabolic regulation and glucose-control research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/474492335",
  },
  "melanotan-ii": {
    name: "MT-2 (Melanotan 2)",
    type: "Cyclic heptapeptide",
    aminoAcids: 7,
    formula: "C\u2085\u2080H\u2086\u2089N\u2081\u2085O\u2089",
    weight: "1,024.18 Da",
    mechanism: "Melanocortin receptor agonist (MC1R / MC3R / MC4R / MC5R). Pigmentation research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/92432",
  },
  "nad-plus": {
    name: "NAD⁺",
    type: "Pyridine nucleotide coenzyme",
    aminoAcids: "N/A (nucleotide)",
    formula: "C\u2082\u2081H\u2082\u2087N\u2087O\u2081\u2084P\u2082",
    weight: "664.43 Da",
    mechanism: "Electron carrier. Cellular energy and metabolic research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/5730",
  },
  "pt-141": {
    name: "PT-141 (Bremelanotide)",
    type: "Cyclic hexapeptide",
    aminoAcids: 6,
    formula: "C\u2085\u2080H\u2086\u2088N\u2081\u2084O\u2081\u2080",
    weight: "1,025.2 Da",
    mechanism: "Melanocortin receptor agonist.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/9941379",
  },
  "selank": {
    name: "Selank",
    type: "Tuftsin analog (heptapeptide)",
    aminoAcids: 7,
    formula: "C\u2083\u2083H\u2085\u2087N\u2081\u2081O\u2089",
    weight: "751.87 Da",
    mechanism: "Sequence Thr-Lys-Pro-Arg-Pro-Gly-Pro. Anxiolytic and immune-modulation research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/11765600",
  },
  "semax": {
    name: "Semax",
    type: "ACTH-derived heptapeptide",
    aminoAcids: 7,
    formula: "C\u2083\u2087H\u2085\u2081N\u2089O\u2081\u2080S",
    weight: "813.92 Da",
    mechanism: "Sequence Met-Glu-His-Phe-Pro-Gly-Pro. Cognitive-pathway research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/9811102",
  },
  "tb-500": {
    name: "TB-500 (Thymosin β-4)",
    type: "Full-length thymosin β-4",
    aminoAcids: 43,
    formula: "C\u2082\u2081\u2082H\u2083\u2085\u2080N\u2085\u2086O\u2087\u2088S",
    weight: "4,963 Da",
    mechanism: "Tissue repair, wound healing and cellular regeneration research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/16132341",
  },
  "tesamorelin": {
    name: "Tesamorelin",
    type: "Modified GHRH analog",
    aminoAcids: 44,
    formula: "C\u2082\u2082\u2081H\u2083\u2086\u2086N\u2087\u2082O\u2086\u2087S",
    weight: "5,195.9 Da",
    mechanism: "Trans-3-hexenoic acid–modified GHRH. Growth-hormone pathway research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/44147413",
  },
  "cjc1295-ipa": {
    name: "CJC-1295 (No DAC)",
    type: "Modified GHRH analog",
    aminoAcids: 30,
    formula: "C\u2081\u2085\u2082H\u2082\u2085\u2082N\u2084\u2084O\u2084\u2082",
    weight: "3,367.9 Da",
    mechanism: "Strategic amino-acid modifications (Nε30-maleimidopropionyl-[D-Ala²,Gln⁸,Ala¹⁵,Leu²⁷]-Sermorelin-Lys³⁰). Extended-half-life GHRH research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/91976842",
  },
  "mots-c": {
    name: "MOTS-c",
    type: "Mitochondrial-derived peptide",
    aminoAcids: 16,
    formula: "C\u2081\u2080\u2081H\u2081\u2085\u2082N\u2082\u2088O\u2082\u2082S\u2082",
    weight: "2,174.6 Da",
    mechanism: "Mitochondrial-genome-encoded peptide. Cellular energy metabolism and mitochondrial-function research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/176489569",
  },
  "kisspeptin-10": {
    name: "Kisspeptin-10",
    type: "KISS-derived decapeptide",
    aminoAcids: 10,
    formula: "C\u2086\u2083H\u2088\u2083N\u2081\u2087O\u2081\u2084",
    weight: "1,302.4 Da",
    mechanism: "Shortest bioactive fragment of kisspeptin-54. Reproductive neuroendocrine signaling research. Sequence: Tyr-Asn-Trp-Asn-Ser-Phe-Gly-Leu-Arg-Phe-NH\u2082.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/25240297",
  },
  "glutathione": {
    name: "Glutathione",
    type: "Tripeptide antioxidant",
    aminoAcids: 3,
    formula: "C\u2081\u2080H\u2081\u2087N\u2083O\u2086S",
    weight: "307.3 Da",
    mechanism: "γ-L-Glutamyl-L-cysteinyl-glycine (Glu-Cys-Gly). Cellular protection and redox-balance research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/124886",
  },
  "b12": {
    name: "Vitamin B12 (Cyanocobalamin)",
    type: "Cofactor / vitamin",
    aminoAcids: "N/A (cofactor)",
    formula: "C\u2086\u2083H\u2088\u2088CoN\u2081\u2084O\u2081\u2084P",
    weight: "1,355.37 Da",
    mechanism: "Essential vitamin cofactor with cobalt (Co) metal centre. Cellular energy metabolism and DNA-synthesis research.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/16058087",
  },
  "bac-water": {
    name: "Bacteriostatic Water",
    type: "Sterile reconstitution reagent",
    aminoAcids: "N/A",
    formula: "H\u2082O + 0.9% benzyl alcohol",
    weight: "N/A",
    mechanism: "Sterile-filtered water with bacteriostatic preservative for peptide reconstitution.",
    pubchem: null,
  },
  // Pinealon — synthetic tripeptide bioregulator (Khavinson family).
  "pinealon": {
    name: "Pinealon",
    type: "Synthetic tripeptide bioregulator (Glu-Asp-Arg)",
    aminoAcids: 3,
    formula: "C\u2081\u2085H\u2082\u2086N\u2086O\u2088",
    weight: "418.40 Da",
    mechanism: "Studied for pineal gland\u2013modulating and neuroprotective/antioxidant activity in aging and stress models.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/10273502",
  },
  // SS-31 — mitochondria-targeted aromatic-cationic tetrapeptide.
  "ss-31": {
    name: "SS-31 (Elamipretide)",
    type: "Synthetic aromatic-cationic tetrapeptide (D-Arg-Dmt-Lys-Phe-NH\u2082)",
    aminoAcids: 4,
    formula: "C\u2083\u2082H\u2084\u2089N\u2089O\u2085",
    weight: "639.80 Da",
    mechanism: "Binds cardiolipin on the inner mitochondrial membrane, stabilizing cristae structure and reducing reactive oxygen species.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/11764719",
  },
  // DSIP — Delta sleep-inducing peptide (research neuropeptide).
  "dsip": {
    name: "DSIP",
    type: "Neuropeptide (nonapeptide)",
    aminoAcids: 9,
    formula: "C\u2083\u2085H\u2084\u2088N\u2081\u2080O\u2081\u2085",
    weight: "848.82 Da",
    mechanism: "Nonapeptide (Trp-Ala-Gly-Gly-Asp-Ala-Ser-Gly-Glu) studied for modulation of sleep architecture; proposed activity via NMDA receptor and hypothalamic signaling.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/68816",
  },
  // 5-Amino-1MQ — small-molecule NNMT inhibitor.
  "amino-1mq": {
    name: "5-Amino-1MQ",
    type: "Small molecule (NNMT inhibitor)",
    aminoAcids: "N/A (small molecule)",
    formula: "C\u2081\u2080H\u2081\u2081N\u2082\u207A",
    weight: "\u2248 159.21 Da",
    mechanism: "Substrate-competitive inhibitor of nicotinamide N-methyltransferase (NNMT); blocks nicotinamide methylation, studied for effects on NAD\u207A availability in metabolic research models.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/5-Amino-1-methylquinolinium",
  },
  // Cagrilintide — long-acting amylin analog (dual amylin/calcitonin agonist).
  "cagrilintide": {
    name: "Cagrilintide",
    type: "Long-acting amylin analog (dual amylin / calcitonin receptor agonist)",
    aminoAcids: 37,
    formula: "C\u2081\u2089\u2084H\u2083\u2081\u2082N\u2085\u2084O\u2085\u2089S\u2082",
    weight: "\u2248 4,409 Da",
    mechanism: "C18 fatty diacid lipidation enables albumin binding for extended half-life; activates AMY1/AMY2/AMY3 amylin and calcitonin receptors, studied in appetite-regulation research models.",
    pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/171397054",
  },
  // WOLVERINE — BPC-157 + TB-500 research blend. Rendered as two component profiles.
  "wolverine": {
    name: "Wolverine (BPC-157 + TB-500)",
    type: "Regenerative research blend",
    isBlend: true,
    blendNote: "A research blend of two peptides. Component profiles below.",
    components: [
      {
        name: "BPC-157",
        type: "Synthetic pentadecapeptide",
        aminoAcids: 15,
        formula: "C\u2086\u2082H\u2089\u2088N\u2081\u2086O\u2082\u2082",
        weight: "1,419.55 Da",
        mechanism: "Body Protective Compound. Supports tissue repair and cellular signaling.",
        pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/Bpc-157",
      },
      {
        name: "TB-500 (Thymosin \u03b2-4)",
        type: "Synthetic 43-amino-acid peptide fragment",
        aminoAcids: 43,
        formula: "C\u2082\u2081\u2082H\u2083\u2085\u2080N\u2085\u2086O\u2087\u2088S",
        weight: "4,963.55 Da",
        mechanism: "Actin-regulating peptide that promotes cell migration and systemic tissue repair signaling.",
        pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/Thymosin-beta-4",
      },
    ],
  },
  // GLOW — proprietary triple blend. Rendered as three component profiles.
  "glow": {
    name: "Glow (Triple Blend)",
    type: "Proprietary blend",
    isBlend: true,
    blendNote: "A proprietary blend of three research compounds. Component profiles below.",
    components: [
      {
        name: "BPC-157",
        type: "Synthetic pentadecapeptide",
        aminoAcids: 15,
        formula: "C\u2086\u2082H\u2089\u2088N\u2081\u2086O\u2082\u2082",
        weight: "1,419.55 Da",
        mechanism: "Tissue repair and cellular-signaling research.",
        pubchem: "https://pubchem.ncbi.nlm.nih.gov/#query=BPC-157",
      },
      {
        name: "TB-500 (Thymosin β-4)",
        type: "Full-length thymosin β-4",
        aminoAcids: 43,
        formula: "C\u2082\u2081\u2082H\u2083\u2085\u2080N\u2085\u2086O\u2087\u2088S",
        weight: "4,963 Da",
        mechanism: "Tissue repair, wound healing and cellular regeneration research.",
        pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/16132341",
      },
      {
        name: "GHK-Cu",
        type: "Copper tripeptide complex",
        aminoAcids: 3,
        formula: "C\u2081\u2084H\u2082\u2082CuN\u2086O\u2084",
        weight: "401.91 Da",
        mechanism: "Collagen synthesis and skin-support research.",
        pubchem: "https://pubchem.ncbi.nlm.nih.gov/compound/73587",
      },
    ],
  },
};

export const getCompoundProfile = (slug) => COMPOUND_PROFILES[slug] || null;
